/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type { AiPromptBatchesWebhookControllerHandleOpenAIWebhookMutationResponse } from '../types/AiPromptBatchesWebhookControllerHandleOpenAIWebhook.ts';

function getAiPromptBatchesWebhookHandleOpenAIWebhookUrl() {
  const res = { method: 'POST', url: `/api/webhooks/openai/ai-prompt-batches` as const };
  return res;
}

/**
 * {@link /api/webhooks/openai/ai-prompt-batches}
 */
export async function aiPromptBatchesWebhookHandleOpenAIWebhook(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    AiPromptBatchesWebhookControllerHandleOpenAIWebhookMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'POST', url: getAiPromptBatchesWebhookHandleOpenAIWebhookUrl().url.toString(), ...requestConfig });
  return res.data;
}
